import request, { apiService2 } from '../utils/request';


export function pVentasRequest(data) {
    return request({
        url: 'dashboard/pventas',
        method: 'post',
        data
    })
}

export function invoicesRequest(data) {
    return request({
        url: 'dashboard/invoices',
        method: 'post',
        data
    })
}

// export function findAllRequest(data) {
//     return request({
//         url: 'dashboard/findAll/invoices',
//         method: 'post',
//         data
//     })
// }

// Listas de pventas según API
const urlsConfig = {
    api2: [
        'mimos-hospitalpablotobonuribe',
        'mimos-cityplaza',
        'mimos-primaveraurbana',
        'mimos-citymedica',
        'mimos-vivavillavicencio',
        'mimos-ipiales',
        'mimos-parqueguarne',
        'mimos-estrella',
        'mimos-jardin',
        'mimos-florida',
        'mimos-santafe',
        'mimos-fabricato3',
        'mimos-puertadelnorte',
        'mimos-eurolafrontera',
        'mimos-florencia',
        'mimos-santuario',
        'mimos-plazabeillin',
        'mimos-vegasplaza',
        'macehticos-santafe',
        'mimos-aventura',
        'mimos-carmendeviboral',
        'macehticos-fabricato',
        'macehticos-sannicolas',
        'macehticos-mayorca',
        'macehticos-plazabeillin',
        'mimos-vivawajira',
        'macehticos-mallotraparte',
        'mimos-bosqueplaza',
        'mimos-eltesoro',
        'mimos-aeropuertopalmira',
        'mimos-bicentenario',
        'macehticos-lacentral',
        'mimos-plazadelrio',
        'macehticos-aventura',
        'mimos-guatapuri',
        'macehticos-terminaldelnorte',
        'macehticos-aguacatala',
        'macehticos-llanogrande',
        'mimos-nuestrouraba',
        'mimos-fabricato2',
        'mimos-jauladelangel',
        'mimos-laestacion',
        'mimos-plazaflora',
        'mimos-multicentro',
        'mimos-lemont',
        'mimos-parqueexplora',
        'mimos-florida2',
        'mimos-diamante',
        'macehticos-diamante',
        'mimos-distritovera'
    ], 
};

export async function findAllRequest(data) {
  const pventa = data.pventa?.trim();

  // Si pventa está vacío → buscar en ambas
  if (!pventa) {
    const [res1, res2] = await Promise.all([
      request({ url: 'dashboard/findAll/invoices', method: 'post', data }),
      apiService2.post('dashboard/findAll/invoices', data),
    ]);
    return {
      data: {
        data: [...(res1.data.data || []), ...(res2.data.data || [])],
      },
    };
  }

  if (urlsConfig.api2.includes(pventa)) {
    return apiService2.post('dashboard/findAll/invoices', data);
  } else {
    return request({ url: 'dashboard/findAll/invoices', method: 'post', data });
  }
}

export function typeInvoicesRequest(data) {
    return request({
        url: `dashboard/invoices/by/pventa`,
        method: 'post',
        data
    })
}

export function updateInvoicesRequest(data) {
    return request({
        url: `/check-in/update`,
        method: 'post',
        data
    })
}

export function ErrosInvoicesRequest(data) {
    return request({
        url: `/check-in/errors`,
        method: 'post',
        data
    })
}
